import { render, staticRenderFns } from "./detialCustom.vue?vue&type=template&id=5486bc1f&scoped=true&"
import script from "./detialCustom.vue?vue&type=script&lang=js&"
export * from "./detialCustom.vue?vue&type=script&lang=js&"
import style0 from "./detialCustom.vue?vue&type=style&index=0&id=5486bc1f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5486bc1f",
  null
  
)

export default component.exports